import { createFont, getVariableValue, isWeb } from 'tamagui';

const sizeLineHeightBody = (size: number) => Math.round(size * 1.1 + (size >= 12 ? 8 : 4));
const siszeLineHeightHeading = (size: number) => Math.round(size * 1.1 + (size < 32 ? 10 : 12));
const fontSize = {
  1: 11,
  2: 12,
  3: 13,
  4: 14,
  true: 14,
  5: 16,
  6: 18,
  7: 20,
  8: 23,
  9: 30,
  10: 46,
  11: 55,
  12: 62,
  13: 72,
  14: 92,
  15: 114,
  16: 134
} as const;

const headingSize = {
  ...fontSize,
  5: 13,
  6: 15,
  7: 20,
  8: 23,
  9: 32,
  10: 44
} as const;

const poppins = createFont({
  family: isWeb ? 'Poppins' : 'Poppins_400Regular',
  size: fontSize,
  lineHeight: Object.fromEntries(
    Object.entries(fontSize).map(([k, v]) => [k, sizeLineHeightBody(getVariableValue(v))])
  ),
  weight: {
    1: '400',
    2: '400',
    3: '400',
    4: '400',
    5: '400',
    6: '400',
    7: '600',
    8: '600',
    9: '600'
  },
  letterSpacing: {
    4: 0
  },
  face: {
    // for native
    400: { normal: 'Poppins_400Regular', italic: 'Poppins_400Regular_Italic' },
    600: { normal: 'Poppins_600SemiBold', italic: 'Poppins_600SemiBold_Italic' },
    bold: { normal: 'Poppins_600SemiBold', italic: 'Poppins_600SemiBold_Italic' }
  }
});

const poppinsHeading = createFont({
  family: isWeb ? 'Poppins' : 'Poppins_500Medium',
  size: headingSize,
  lineHeight: Object.fromEntries(
    Object.entries(headingSize).map(([k, v]) => [k, siszeLineHeightHeading(getVariableValue(v))])
  ),
  weight: {
    1: '500',
    2: '500',
    3: '500',
    4: '500',
    5: '500',
    6: '600',
    7: '700',
    8: '800',
    9: '900'
  },
  letterSpacing: {
    4: 0
  },
  face: {
    // for native
    500: { normal: 'Poppins_500Medium', italic: 'Poppins_500Medium_Italic' },
    600: { normal: 'Poppins_600SemiBold', italic: 'Poppins_600SemiBold_Italic' },
    700: { normal: 'Poppins_700Bold', italic: 'Poppins_700Bold_Italic' },
    800: { normal: 'Poppins_800ExtraBold', italic: 'Poppins_800ExtraBold_Italic' },
    900: { normal: 'Poppins_900Black', italic: 'Poppins_900Black_Italic' },
    bold: { normal: 'Poppins_700Bold', italic: 'Poppins_700Bold_Italic' }
  }
});

export const fonts = {
  body: poppins,
  heading: poppinsHeading
};
